import { IAffairPub, IAffairUploadImageApi, IAttachmentImage } from "@api/affair.int";
import { Box, Button, FormControl, FormLabel, Input } from "@chakra-ui/react";
import { useDeepAuth, useVVApi } from "components/api";
import { AFFAIR_KINDS, Bogyo2 } from "components/appComponents";
import { DeepErrorBox } from "components/misc";
import { useVVStore } from "components/store";
import { VizvButtonBack, VizvButtonCancel, VizvCard, VizvCardAction, VizvCardActionStrip, VizvCardContent, VizvMainCol } from "components/vizvComponents";
import { GuardKindBox } from "features/profile/Profile";
import * as domToImage from 'dom-to-image';
import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { MIME } from "./AffairImageUpload";
import { AffairContext } from "./Affair";

const SIZEX = 800;
const SIZEY = 450;


type TCaptureMapStage = 'MAP' | 'ADD' | 'CONFIRM';

export function AffairCaptureMap() {
    const mapNavRoot = useVVStore(state => state.mapNavRoot);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const api = useVVApi();
    const [stage, setStage] = useState<TCaptureMapStage>('MAP');
    const params = useParams();
    const addAffairItems = useVVStore(state => state.addAffairItems);
    const affairList = useVVStore(state => state.affairList);
    const affair = affairList.find(a => a.affairKey === params.affairKey) as IAffairPub;
    const authCtx = useDeepAuth();
    const nav = useNavigate();


    const [kekSzoveg, setKekSzove] = useState(AFFAIR_KINDS[affair.affairKind].name);
    const [zoldSzoveg, setZoldSzove] = useState(affair.title);
    const [buborekSzoveg, setBuborekSzove] = useState('Figyelek!');

    const onCapture = () => {
        const map = document.getElementById("map");
        if (!map)
            return setError('no map');


        (domToImage as any).toPng(map).then(function (dataUrl: string) {
            setStage('ADD');
            setTimeout(() => {
                const mapCopy = document.getElementById("mapCopy") as HTMLCanvasElement;
                if (!mapCopy)
                    return setError('no mapCopy');
                /*const ctx = mapCopy.getContext('2d');
                if (!mapCopy)
                    return setError('nom mapCopy.context');
                ctx?.drawImage(canvas, 0, 0, SIZEX, SIZEY);
                mapCopy.innerHTML = '';
                setTimeout(() => {
                    canvas.setAttribute('width', '' + SIZEX);
                    canvas.setAttribute('height', '' + SIZEY);
                }, 1000)
                */

                var img = new Image();
                img.src = dataUrl;
                img.style.width = SIZEX + 'px';
                img.style.height = SIZEY + 'px';
                img.style.objectFit = 'cover';
                mapCopy.appendChild(img);

            }, 1000)

        });
    }

    /*const toConfirm = async () => {
        setError(''); setIsLoading(false);
        const composedImgDiv = document.getElementById("composedImgDiv");
        if (!composedImgDiv)
            return setError('no composedImgDiv');

        (domToImage as any).toPng(composedImgDiv).then(function (dataUrl: string) {
            console.log(dataUrl);
            setStage('CONFIRM');


            setTimeout(() => {

                const confirmImgDiv = document.getElementById("confirmImgDiv");
                if (!confirmImgDiv)
                    return setError('no confirmImgDiv');

                var img = new Image();
                img.src = dataUrl;
                confirmImgDiv.appendChild(img);
            }, 2000);
        });
    }*/

    const uploadImage = async () => {
        setIsLoading(true);

        const composedImgDiv = document.getElementById("composedImgDiv");
        if (!composedImgDiv)
            return setError('no composedImgDiv');


        (domToImage as any).toBlob(composedImgDiv).then(async function (blob: any) {
            debugger;
            try {

                const resp = await api.fetchToast<IAffairUploadImageApi>({
                    url: "/affair/:affairKey/upload-image", method: 'POST',
                    params: {
                        affairKey: affair.affairKey
                    },
                    payload: {
                        mime: MIME
                    }
                });
                console.log('----->', resp);
                console.log('Uploading to: ', resp.uploadURL)
                const result = await fetch(resp.uploadURL, {
                    method: 'PUT',
                    body: blob
                })
                console.log('Result: ', result)
                // Final URL for the user doesn't need the query string params
                console.log('uploadURL', resp.uploadURL.split('?')[0]);

                const newAffair: IAffairPub = {
                    ...affair,
                    attachments: {
                        ...affair.attachments,
                        [resp.metadata.attachmentKey]: {
                            attachKind: 'uploded_image',
                            createdAt: 'most',
                            key: resp.key,
                            user: {
                                ...authCtx.userConfirmed
                            }
                        } as IAttachmentImage
                    }
                }
    
                // refresh in store, and refresh here...
                addAffairItems([newAffair]);
                nav('/affair/'+affair.affairKey + '/attachment/' + resp.metadata.attachmentKey);
            } catch (ex) {
                setError(''+ex);
            } finally {
                setIsLoading(false);
            }
        })
    }



    return <>
        {stage === 'MAP' &&
            <VizvMainCol isTool={{ width: 400, isDetailed: false }}>
                <VizvCard isTool isClosable >
                    <DeepErrorBox error={error} />
                    <VizvCardContent>
                        <Button onClick={onCapture}>Csííz</Button>
                    </VizvCardContent>

                </VizvCard>
            </VizvMainCol>}
        {stage === 'ADD' && <VizvMainCol>
            <VizvCard>
                <DeepErrorBox error={error} />
                <VizvCardContent>
                    <FormControl>
                        <FormLabel>Kék szöveg</FormLabel>
                        <Input value={kekSzoveg} onChange={e => setKekSzove(e.target.value)} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Zöld szöveg</FormLabel>
                        <Input value={zoldSzoveg} onChange={e => setZoldSzove(e.target.value)} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Buborék szöveg</FormLabel>
                        <Input value={buborekSzoveg} onChange={e => setBuborekSzove(e.target.value)} />
                    </FormControl>
                    <Box position='relative'>
                        <Box id='composedImgDiv'
                            position='relative'
                        >
                            <Box id='mapCopy' width={SIZEX + 'px'} height={SIZEY + 'px'} />
                            <Box
                                position='absolute' bottom='40px' left='0'
                                bg='primary.main' color='#000' p='4px 1em 4px 6px'
                                fontWeight='400' fontSize='3xl'
                                display='flex' maxH='40px'
                            ><Bogyo2
                                    kind={affair.affairKind}
                                    position='relative' top='-15px' left='0' right='0' bottom='0'
                                    boxShadow='md' zIndex={1} mr={2}
                                />
                                {kekSzoveg}</Box>
                            <Box position='absolute' bottom='7px' left='0'
                                bg='secondary.main' color='#000' p='0px 1em'
                                fontSize='.85em' fontWeight='400'
                            >{zoldSzoveg}</Box>
                            <Box position='absolute' bottom='0px' right='10px'>
                                <GuardKindBox guardKind={authCtx.userConfirmed?.guard?.kind || '00'} guardName={authCtx.userConfirmed?.guard?.name || authCtx.userConfirmed?.userName} />
                            </Box>
                            <Box className="talkBubble"
                                position='absolute' bottom='100px' right='35px'
                                bg='#f7f7f7' color='#000' p='0px 1em' border='2px solid #000c' borderRadius='xl'
                                fontSize='sm' fontWeight='500'
                            >{buborekSzoveg}</Box>
                        </Box>
                    </Box>
                </VizvCardContent>
                <VizvCardActionStrip>
                    <VizvButtonBack onClick={() => setStage('MAP')}>Új kép</VizvButtonBack>
                    {/*<VizvCardAction onClick={() => toConfirm()}>Így jó</VizvCardAction>*/}
                    <VizvCardAction onClick={() => uploadImage()}>Feltöltés</VizvCardAction>                    
                </VizvCardActionStrip>

            </VizvCard>
        </VizvMainCol>}
        {stage === 'CONFIRM' && <VizvMainCol>
            <VizvCard>
                <DeepErrorBox error={error} />
                <VizvCardContent>
                    <Box id='confirmImgDiv' />
                </VizvCardContent>
                <VizvCardActionStrip>
                    <VizvButtonCancel onClick={() => setStage('ADD')}>Vissza</VizvButtonCancel>
                    <VizvCardAction onClick={() => uploadImage()}>Megosztom</VizvCardAction>
                </VizvCardActionStrip>

            </VizvCard>
        </VizvMainCol>}
    </>
}